<template>
    <section>
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">All Warehouses</h5>
                      <span v-if="!isBranchUser">
                        <a class="pull-right" v-on:click="loadAddNewRestaurantModal()" v-if="userRole === 'ADMIN'">Add New Warehouse</a>
                        <a class="pull-right" v-on:click="loadRestaurantCategoriesModal()" v-if="userRole === 'ADMIN'">Add Warehouse Categories&emsp;</a>
                        <a class="pull-right" v-on:click="loadAllBrands()">All Brands&emsp;</a>
                        </span>
                    </div>
                    <div class="ibox-content">
                      <div class="row" v-if="!isBranchUser">
                        <div class="form-group col-md-3">
                          <label>Select Categories</label>
                          <multiselect v-model="categories" :options="options.map(type => type.id)" :custom-label="opt => options.find(x => x.id === opt).name" :multiple="false" :close-on-select="true"></multiselect>
                        </div>
                        <div class="col-md-3">
                          <label>Portal Enable</label>
                          <select id="customer_deleted" v-model="enablePortal" class="form-control custom_width">
                            <option value="NO">NO</option>
                            <option value="YES">YES</option>
                            <option value="All">ALL</option>
                          </select>
                        </div>
                        <div class="col-md-3">
                          <label>Enable On Bebambi</label>
                          <select id="customer_deleted" v-model="enbleOnBayked" class="form-control custom_width">
                            <option value="NO">NO</option>
                            <option value="YES">YES</option>
                            <option value="All">ALL</option>
                          </select>
                        </div>
                        <div class="col-md-3">
                          <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_btn" type="button"><i class="fa fa-search"></i> Search</button>
                          <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_btn"><i class="fa fa-refresh" type="button"></i> Refresh</button>
                        </div>
                      </div>
                      <div class="table-responsive">
                            <table class="table table-striped table-responsive table-bordered table-hover" id="dtTable">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>UAN</th>
                                    <th>Type</th>
                                    <th>Created</th>
                                    <th>Modified</th>
                                    <th>On Bebambi</th>
                                    <th>Disabled</th>
                                    <th>Story</th>
                                    <th class="text-center"><i class="fa fa-bolt"></i></th>
                                </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AddUpdateRestaurant ref="addUpdateResPopUp"/>
        <AddUpdateResCategories ref="addUpdateResCategoriesPopUp"/>
        <AddUpdateBranch ref="addUpdateBranchPopUp" />
        <AddUpdateMenu ref="addUpdateMenuPopUp" />
        <AddUpdateAdOns ref="addUpdateAdOnsPopUp" />
        <initialize-feedback-for-branch ref="initFeedbackPopUp"></initialize-feedback-for-branch>
        <addTablesAndWaiters ref="addTables"></addTablesAndWaiters>
        <add-story ref="addRestaurantStory"/>
        <LoadAllBrands
            ref="loadAllBrands"

        />
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import AddUpdateRestaurant from '@/components/restaurants/AddUpdateRestaurant'
    import AddUpdateResCategories from '@/components/restaurants/AddUpdateResCategories'
    import AddUpdateBranch from '@/components/restaurants/AddUpdateBranch'
    import AddUpdateMenu from "../components/restaurants/AddUpdateMenu";
    import AddUpdateAdOns from "../components/restaurants/AddUpdateAdOns";
    import InitializeFeedbackForBranch from "../components/restaurants/InitializeFeedbackForBranch";
    import addTablesAndWaiters from "../components/restaurants/addTablesAndWaiters";
    import AddStory from "../components/restaurant_story/AddStory";
    import Multiselect from 'vue-multiselect'
    import LoadAllBrands from "@/components/brands/LoadAllBrands.vue";
    export default {
        name: "Restaurants",
        data() {
            return {
                dtTable: null,
                selectedRow: {},
                userRole: "",
                enablePortal: "All",
                enbleOnBayked: "All",
                allBranches:[],
                branchId: "",
                branchName: "",
                restaurantId: "",
                categories: "",
                restName: "",
                options:[],
            }
        },
      computed: {
        isBranchUser(){
          return this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
        }
      },
        components: {
            LoadAllBrands,
            InitializeFeedbackForBranch,
            AddUpdateAdOns,
            AddUpdateMenu,
            AddUpdateBranch,
            PageTitle,
            AddUpdateRestaurant,
            AddUpdateResCategories,
            addTablesAndWaiters,
            AddStory,
            Multiselect
        },
        mounted: function () {
            this.userRole = this.$store.state.user.userRolesById[0].role.split('_')[1];
            let self = this;
            !self.isBranchUser && self.getCategories()
            let processingURL = this.$store.state.mainAppURL + "restaurants/get_all_restaurants_for_dt";
            self.dtTable = $('#dtTable').DataTable({
                "processing": true,
                "serverSide": true,
                "searching": !self.isBranchUser,
                autoWidth: false,
                "lengthMenu": [10, 25, 50, 100, 250],
                'language': {
                    //'loadingRecords': 'Please wait - loading...',
                    "infoFiltered": "",
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "order": [[0, "desc"]],
                "initComplete": function () {
                    var api = this.api();
                    if ( self.userRole ==='USER' ) {
                      api.column(6).visible(false); //on delivery monster column
                      api.column(7).visible(false); //disable column
                    } if (self.userRole !== 'ADMIN') {
                      api.column(8).visible(false); // restaurant stories
                  }
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                        d.categoryId = self.categories
                        d.enablePortal = self.enablePortal
                        d.enbleOnBayked = self.enbleOnBayked
                        return JSON.stringify( d );
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr) => {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(this.dtTable);
                      }
                    }
                },
                "columnDefs": [
                    { "orderable": false, "targets": [1,2,3,4,7,8,9] },
                    { 'className': "text-center", 'aTargets': [0,3,4,5,6,7,8,9]},
                ],
                "columns": [
                    { "data": "id", "name":"id" },
                    {
                        "data": "name","name":"name",
                        render: function (data, type, row) {
                            return "<a data-id='"+row.id+"' class='showRestaurantDetailBtn'>"+data+"</a>"
                        }
                    },
                    {"data": "uan","name":"uan"},
                    {"data": "type","name":"type"},
                    {
                        "data": "created",
                        "name":"created",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "modified",
                        "name":"modified",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "onDeliveryMonster","name":"onDeliveryMonster",
                        "render": function(data){
                            if(data){
                                return "<label class='label label-success'>Yes</label>"
                            }else{
                                return "<label class='label label-danger'>No</label>"
                            }
                        }
                    },
                    {
                        "data": "deleted","name":"deleted",
                        "render": function(data){
                            if(data){
                                return "<label class='label label-danger'>Yes</label>"
                            }else{
                                return "<label class='label label-success'>No</label>"
                            }
                        }
                    },
                  {
                    "data": "Story","name":"restaurantStory",
                    "render": function(){
                      return '<button type="button" class="btn btn-xs btn-link addStoryBtn">View</button>'
                    }
                  },
                    {
                        "data":"action", "name": "action",
                        render: function (data,type,row) {
                            return "<a data-id='"+row.id+"' class='viewBranchesBtn'>Vendors <i class='fa fa-chevron-down branch_btn_arrow'></i></a>"
                        }
                    },
                ],
                "rowCallback": function (row) {
                  $("tr", row).css({"white-space": "nowrap"});
                },
                "drawCallback": function( settings ) {
                    $(".m_tip").tooltip();
                    $(".showRestaurantDetailBtn").click(function () {
                        !self.isBranchUser && self.$refs.addUpdateResPopUp.load($(this).attr("data-id"));
                    });
                    $(".viewBranchesBtn").click(function () {
                        let tr = $(this).closest('tr');
                        let resId = $(this).attr("data-id");
                        self.selectedRow[resId] = self.dtTable.row( tr );
                        $(this).children().eq(0).removeClass("fa-chevron-down");
                        $(this).children().eq(0).removeClass("fa-chevron-up");
                        if(self.selectedRow[resId].child.isShown()){
                            tr.removeClass("info");
                            $(this).children().eq(0).addClass("fa-chevron-down");
                            self.selectedRow[resId].child.hide();
                        }else{
                            tr.addClass("info");
                            $(this).children().eq(0).addClass("fa-chevron-up");
                            self.loadBranchesOfRestaurant(self.selectedRow[resId]);

                        }
                    });
                  $(".addStoryBtn").click(function () {
                    let tr = $(this).closest('tr');
                    let resId = $(this).attr("data-id");
                    self.selectedRow[resId] = self.dtTable.row( tr );
                    self.loadAddNewRestaurantStoryModal(self.selectedRow[resId]);
                  });
                }
            });
          $(".search_btn").click(function(){
            self.dtTable.search('');
            // dtTable.column(4).search(self.selectedCityId.id);
            //
            self.dtTable.draw();
            console.log("search")
          });
          $(".refresh_btn").click(function(){
            self.categories = ""
            self.enablePortal = "All"
            self.enbleOnBayked = "All"
            self.dtTable.draw();
            console.log("refresh")
          });
            $.fn.dataTable.ext.errMode = 'none';
            let dtTableFilterSelector = $("#dtTable_filter input");
            dtTableFilterSelector.unbind();
            dtTableFilterSelector.attr("size","35");
            dtTableFilterSelector.attr("placeholder", "Search On Name or Type of warehouse....");
            dtTableFilterSelector.keyup(function (e) {
                if(e.keyCode === 13) {
                    self.dtTable.search($(this).val()).draw();
                }
            });
        },
        methods: {
            getCategories() {
              this.$http.get(this.$store.state.mainAppURL + "restaurant_categories/").then(resp => {
                this.options = resp.data;
              });
            },
            loadAddNewRestaurantModal: function () {
                this.$refs.addUpdateResPopUp.load(0);
            },
            loadAddNewRestaurantStoryModal: function (row) {
              let rowData = row.data();
              this.$refs.addRestaurantStory.load(rowData.id);
            },
            loadRestaurantCategoriesModal: function () {
                this.$refs.addUpdateResCategoriesPopUp.load();
            },
            loadBranchesOfRestaurant: function (row) {
                let self = this;
                let rowData = row.data();
                let params = new URLSearchParams();
                params.append("restaurant_id", rowData.id);
                params.append("is_portal_enabled", self.enablePortal);
                params.append("is_enable_on_bayked", self.enbleOnBayked);
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                    let response = resp.data;
                    self.allBranches= resp.data;
                    let html = '<h3 class="pull-left"> Vendors of '+rowData.name+'';
                    if(self.userRole!=='USER' && self.userRole!=='BRANCH'){
                        html+='<small><button data-res-id="'+rowData.id+'" data-res-name="'+rowData.name+'" class="btn btn-sm btn-link addNewAdOnCategory">Ad On\'s Of '+rowData.name+'</button></small>';
                    }
                    if(self.userRole!=='AGENT' && self.userRole!=='BRANCH'){
                        html+='<small><button data-res-id="'+rowData.id+'" data-res-name="'+rowData.name+'" class="btn btn-sm btn-link addNewBranchBtn">Add New Vendor</button></small>';
                    }
                    html+='</h3><table style="overflow-x: auto; table-layout:fixed !important " class="table table-bordered table-striped">';
                    html += "<tr>" +
                        "<th class='text-center'>Area</th>" +
                        "<th class='text-center'>City</th>" +
                        "<th class='text-center'>Portal Enable</th>" +
                        "<th class='text-center'>Enabled On Bebambi</th>" +
                        "<th class='text-center'>Phone</th>" +
                        "<th class='text-center'>Created</th>" +
                        "<th class='text-center'>Modified</th>" +
                        "<th class='text-center'>Is 24 Hours Open</th>" +
                        "<th class='text-center'>Delivery Radius</th>" +
                        "<th class='text-center'>Minimum Order</th>" +
                        "<th class='text-center'>Is Free Delivery</th>" +
                        "<th class='text-center'>Tax Amount Charged</th>";
                        if(self.userRole==='ADMIN'){
                            html+="<th class='text-center'>Feedback App</th>";
                        }
                        html+="<th class='text-center'>Brands</th>";
                        if(!self.isBranchUser) {
                          html += "<th class='text-center'>Menu <i class='fa fa-bolt'></i></th>"
                        }
                        html+="</tr>";
                    for(let i = 0; i < response.length; i++){
                        let Hrs24 = (response[i].open24Hours) ? "Yes" : "No";
                        let isFreeDelivery = (response[i].freeDelivery) ? "Yes" : "No";
                        let isEnabledOnBayked = (response[i].isEnable) ? "Yes" : "No";
                        let isPortalEnabled = (response[i].isPortalEnabled) ? "Yes" : "No";
                        self.restName = response[i].restaurantsByRestaurantId.name;
                        html += "<tr data-res-name='"+response[i].restaurantsByRestaurantId.name+
                            "' data-res-id='"+response[i].restaurantsByRestaurantId.id+
                            "' data-branch-id='"+response[i].id+
                            "' data-branch-name='"+response[i].areasByAreaId.name+"'>" +
                            "<td class='text-center'><a class='editBranchBtn' href='javascript:void(0)'>"+response[i].areasByAreaId.name+"</a></td>" +
                            "<td class='text-center'>"+response[i].areasByAreaId.citiesByCityId.city+"</td>" +
                            "<td class='text-center'>"+isPortalEnabled+"</td>" +
                            "<td class='text-center'>"+isEnabledOnBayked+"</td>" +
                            "<td class='text-center'>"+response[i].phone1+"</td>" +
                            "<td class='text-center'>"+self.$moment.parseZone(String(response[i].created)).local().format('DD/MM/YYYY hh:mm:ss A')+"</td>" +
                            "<td class='text-center'>"+self.$moment.parseZone(String(response[i].modified)).local().format('DD/MM/YYYY hh:mm:ss A')+"</td>" +
                            "<td class='text-center'>"+Hrs24+"</td>" +
                            "<td class='text-center'>"+response[i].deliveryRadius+" Km</td>" +
                            "<td class='text-center'>"+response[i].minimumOrder+" Rs.</td>" +
                            "<td class='text-center'>"+isFreeDelivery+"</td>" +
                            "<td class='text-center'>"+response[i].tax+" %</td>";
                            if(self.userRole==='ADMIN'){
                                html+="<td class='text-center'><a class='init_feedback_app' href='javascript:void(0)'>Initialize</a></td>";
                            }
                            html+="<td class='text-center'><a class='view_brands' disabled='"+self.isBranchUser+"' href='javascript:void(0)'>View</a></td>";
                            if(!self.isBranchUser) {
                              html+="<td class='text-center'>" +
                                  "<a class='view_menu_btn' disabled='"+self.isBranchUser+"' href='javascript:void(0)'>View</a>" +
                                  "</td>";
                            }
                            html+="</tr>";
                    }
                    if(response.length === 0){
                        html += "<tr><td colspan='12'>No Branches Available</td></tr>";
                    }
                    html += "</table>";
                    row.child(html).show();
                    $(".editBranchBtn").click(function () {
                        let branchId = $(this).closest("tr").attr("data-branch-id");
                        let resId = $(this).closest("tr").attr("data-res-id");
                        let resName = $(this).closest("tr").attr("data-res-name");
                        self.$refs.addUpdateBranchPopUp.load(branchId, resId, resName);
                    });
                    $(".addNewBranchBtn").click(function () {
                        let resId = $(this).attr("data-res-id");
                        let resName = $(this).attr("data-res-name");
                        self.$refs.addUpdateBranchPopUp.load(0, resId, resName);
                    });
                    $(".view_menu_btn").click(function () {
                      self.branchId = $(this).closest("tr").attr("data-branch-id");
                      self.restaurantId = $(this).closest("tr").attr("data-res-id");
                      self.branchName = $(this).closest("tr").attr("data-branch-name");
                      !self.isBranchUser && self.fetchBranchMenu();
                    });
                    $(".addNewAdOnCategory").click(function () {
                        let resId = $(this).attr("data-res-id");
                        let resName = $(this).attr("data-res-name");
                        self.$refs.addUpdateAdOnsPopUp.load(resId, resName);
                    });
                    $(".init_feedback_app").click(function () {
                        let branchId = $(this).closest("tr").attr("data-branch-id");
                        let resId = $(this).closest("tr").attr("data-res-id");
                        let resName = $(this).closest("tr").attr("data-res-name");
                        self.$refs.initFeedbackPopUp.load(resId, resName, branchId);
                    });
                    $(".view_brands").click(function () {
                      let branchId = $(this).closest("tr").attr("data-branch-id");
                      let branchName = $(this).closest("tr").attr("data-branch-name");
                      console.log("Loading brands of branch")
                      !self.isBranchUser && self.$refs.loadAllBrands.loadBabyHugBrands(branchId, branchName);
                    });
                    $('.addTables').click(function(){
                        self.$refs.addTables.loadTableModal(self.allBranches);
                    });
                    $('.addWaiters').click(function(){
                        self.$refs.addTables.loadWaiterModal(self.allBranches);
                    });
                });
            },
            fetchBranchMenu: function(){
              this.$refs.addUpdateMenuPopUp.load(this.branchId, this.restaurantId, this.branchName);
            },
            removeFromObject (index, object){
              this.$refs.addUpdateAdOnsPopUp.removeFromObject(index, object);
            },
            loadAllBrands () {
                this.$refs.loadAllBrands.loadBabyHugBrands()
            }
        }
    }
</script>

<style scoped>

</style>
